document.querySelectorAll('[data-membership]').forEach(root => {
 const form = root.querySelector('[data-member-checkout]');
 const radios = [...root.querySelectorAll('input[type="radio"]')];
 const button = root.querySelector('[data-member-submit]');
 const requestedPlan = new URLSearchParams(window.location.search).get('plan');
 if (requestedPlan === 'monthly' || requestedPlan === 'annual') {
  const requestedRadio = radios.find(radio => radio.value === requestedPlan);
  if (requestedRadio) requestedRadio.checked = true;
 }
 const sync = () => {
  const input = radios.find(radio => radio.checked);
  if (!input) return;
  const annual = input.value === 'annual';
  root.querySelector('[data-member-price]').textContent = input.dataset.price || '';
  root.querySelector('[data-member-period]').textContent = input.dataset.period || '';
  root.querySelector('[data-member-billing]').textContent = input.dataset.billing || '';
  root.querySelector('[data-member-saving]').textContent = input.dataset.saving || '';
  const summary = root.querySelector('[data-member-summary]');
  if (summary) summary.textContent = 'Selected: ' + (annual ? 'Annual' : 'Monthly') + ' · ' + input.dataset.price + (annual ? ' billed upfront annually.' : ' billed monthly.');
  if (!form || !button) return;
  form.elements.id.value = input.dataset.variant || '';
  form.elements.selling_plan.value = input.dataset.plan || '';
  const ready = root.dataset.deliveryReady === 'true' && input.dataset.available === 'true' && /^\d+$/.test(input.dataset.variant || '') && /^\d+$/.test(input.dataset.plan || '');
  button.disabled = !ready;
  button.textContent = ready ? 'Continue to secure checkout' : 'Enrollment unavailable';
  root.querySelector('[data-member-checkout-status]').textContent = ready ? 'Review your recurring plan and payment details at Shopify checkout.' : root.dataset.deliveryReady !== 'true' ? 'Enrollment is not open yet.' : input.dataset.available !== 'true' ? 'This plan is currently unavailable. Choose another plan or contact support.' : 'This subscription plan could not be confirmed. Reload or contact support before continuing.';
 };
 radios.forEach(input => input.addEventListener('change', sync));
 form?.addEventListener('submit', event => {
  if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
  sync();
  if (button.disabled || form.dataset.submitting === 'true') { event.preventDefault(); return; }
  form.dataset.submitting = 'true';
  button.disabled = true;
  button.textContent = 'Opening secure checkout…';
 });
 window.addEventListener('pageshow', () => { if (form) delete form.dataset.submitting; sync(); });
 sync();
});
